import type { BookedSalesSearch } from '@/lib/services/money/money.schema'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { bookedSalesSearchSchema } from '@/lib/services/money/money.schema'

export function redirectLegacyMoneySalesDay({
  params,
  search,
}: {
  params: { orgId: number; date: string }
  search: Partial<BookedSalesSearch>
}) {
  throw redirect({ to: '/$orgId/reports/sales-summary/$date', params, search, replace: true })
}

export const Route = createFileRoute('/_authenticated/$orgId/money/sales/$date')({
  validateSearch: (search) => bookedSalesSearchSchema.parse(search),
  beforeLoad: redirectLegacyMoneySalesDay,
})
